import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedoresService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    onMantenedoresComponentButtonClick() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedoresService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedoresService_Factory() { return new EventMantenedoresService(); }, token: EventMantenedoresService, providedIn: "root" });
